import { queryOptions, type TQueryKey } from '@react/utils/queryHooks';

import type { ITopicVMProps } from '@data/view-models';

import { QK_FETCH_TOPICS, topicApi } from '~/requests/topicApi';

export type TPostsOptions = Omit<
  ReturnType<
    typeof queryOptions<
      ITopicVMProps[],
      Error,
      ITopicVMProps[],
      Array<TQueryKey>
    >
  >,
  'queryFn'
>;

export function topicsOptions(): TPostsOptions {
  return queryOptions({
    queryKey: [QK_FETCH_TOPICS],
    queryFn: async ({ signal }) => {
      return topicApi
        .getTopics({
          signal,
        })
        .catch(() => {
          return [];
        });
    },
  });
}
